module.exports = __webpack_public_path__ + "color.c7a33805ffda0d32bd2a.png";


//////////////////
// WEBPACK FOOTER
// ./~/primeng/resources/images/color.png
// module id = 596
// module chunks = 2